module.exports = __webpack_public_path__ + "img/logo6@2x.8ad9ee47.png";